<div class="classroom-bar" [class.classroom-bar--mobile]="isMobile">
  <div class="lesson-details">
    <div class="tutor-details">
      @if (appointmentType === 'Introduction') {
        <span translate>texts.Misc_Upcoming_Appointment_Intro</span>
      }
      @if (appointmentType === 'Lesson' && appointment.online) {
        <span translate>texts.Misc_Upcoming_Appointment_Online</span>
      }
      @if (appointmentType === 'Lesson' && !appointment.online) {
        <span translate>texts.Misc_Upcoming_Appointment_Home</span>
      }
      &nbsp;<b>{{ appointmentPartner }}</b>
    </div>
    <div class="lesson-time">{{ appointment.begin | date: 'dd-MM-yyyy HH:mm' }}</div>
  </div>

  @if (appointment.online) {
    <div class="classroom-action">
      <div class="join-button" (click)="joinClassroom.emit()">
        <i class="fa-light fa-chalkboard-user"></i>
        <span translate>texts.Misc_Classroom</span>
      </div>
    </div>
  }

</div>
